// removed by extract-text-webpack-plugin
module.exports = {"vpVideoDesignElementContainer":"vpVideoDesignElementContainer___ft5N9","vpVideoDesignElementWarning":"vpVideoDesignElementWarning___538hZ","vpVideoElementPreview":"vpVideoElementPreview___1ZMOE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoElement.module.less
// module id = 3802
// module chunks = 33